import { render, staticRenderFns } from "./organization-question-set-answering.vue?vue&type=template&id=0fa42ce6&scoped=true&"
import script from "./organization-question-set-answering.vue?vue&type=script&lang=js&"
export * from "./organization-question-set-answering.vue?vue&type=script&lang=js&"
import style0 from "./organization-question-set-answering.vue?vue&type=style&index=0&id=0fa42ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa42ce6",
  null
  
)

export default component.exports